  import { useEffect, useState } from "react";

import api from "../../api/Api";
import totalasset from "../../assets/totalasset.png";
import totalassignedasset from "../../assets/totalassignedasset.png";
import totalunassignedasset from "../../assets/totalunassignedasset.png";
import totalIssue from "../../assets/repair.png";
import userNotReturned from "../../assets/usernotreturn.png";
import totalemployee from "../../assets/totalemployees.png";
import "./Dashboard.css"

function DashBoard() {
  const [dashBoard, setDashBoard] = useState(null);

  const imageMap = {
    totalAsset: totalasset,
    totalAssignedAsset: totalassignedasset,
    totalUnassignedAsset: totalunassignedasset,
    totalIssue: totalIssue,
    userNotReturned: userNotReturned,
    totalEmployee: totalemployee
  }

  useEffect(() => {
    api
      .get("/api/dashboard")
      .then((res) => setDashBoard(res.data.response))
      .catch((err) => console.error("Dashboard fetch failed:", err));
  }, []);

  if (!dashBoard) {
    return <div className="container mt-3">Loading dashboard…</div>;
  }


  return (
    <div className="d-flex flex-column">
      <div className="container-fluid py-3 flex-grow-1 d-flex flex-column">
        <div className="row g-4 justify-content-center flex-grow-1">
        
          {Object.entries(dashBoard).map(([key, value], index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
              <div className=" cardLayout card shadow-sm">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-capitalize">
                    <span><img className="icon p-1" src={imageMap[key]} alt={key} /></span>
                    {key.replace(/([A-Z])/g, " $1")}
                  </h5>
                  <p className="display-1 mt-4 text-center">{value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DashBoard;
